import { DISCOUNT_TYPE } from 'general/constants/AppConstants'
import Utils from 'general/utils/Utils'
import _ from 'lodash'
const truncateToSixDecimals = (number, type) => {
  if (type) {
    return number
  } else {
    // Sử dụng toán tử nhân chia để cắt số thập phân
    return Math.floor(number * 1e6) / 1e6
  }
}
export const handleChangeTableData = ({
  e,
  row,
  field,
  type,
  tableData,
  formik,
  setTableData,
  formatNumber,
  roundingConfig,
  isDeliveryBill,
  invoiceType,
  showPriceAfterTax,
  setIsChangeTable,
  isAdjustInvoice,
  persistent,
  invoiceSetting,
  systemTaxRate,
}) => {
  console.log('a')
  setIsChangeTable(true)
  let newTableData = [...tableData]
  let newTableDataLast = newTableData[row.no - 1]
  let { exchangeRate } = formik.values
  if (typeof exchangeRate === 'string') {
    exchangeRate = Utils.parseFormattedNumberToFloat(exchangeRate)
  }
  let taxRate = newTableDataLast.taxRate
  if (
    (taxRate == '0' || taxRate == '5' || taxRate == '8' || taxRate == '10') &&
    (formik.values.taxType === 1 ||
      formik.values.taxType === 2 ||
      (formik.values.taxType === 3 && !formik.values.multipleTaxRate) ||
      formik.values.multipleTaxRate) &&
    parseInt(formik.values?.serial?.charAt(0)) === 1
  ) {
    taxRate = parseInt(taxRate)
  } else if (taxRate !== 'KHAC') {
    taxRate = 0
  }
  var value = e?.floatValue ?? e?.value ?? e?.target?.value
  if (isAdjustInvoice && !formik.values.autoCalculate) {
    newTableDataLast[field] = value
    setTableData(newTableData)
    // return
  }
  switch (type) {
    case 'number':
      // if (e?.floatValue) {
      //   newTableDataLast[field] = e?.floatValue
      // }
      if (e?.target?.value) {
        newTableDataLast[field] = Utils.parseFormattedNumberToFloat(
          e?.target?.value,
        )
      } else {
        if (!formik.values.autoCalculate) {
          newTableDataLast[field] = null
        } else {
          newTableDataLast[field] = 0
        }
      }

      switch (field) {
        case 'discountMoney':
          if (formik.values.discountType != 0) {
            newTableDataLast[field] = e?.target?.value
              ? Utils.parseFormattedNumberToFloat(e.target.value)
              : null
          }
          if (
            !Utils.isObjectEmpty(newTableDataLast?.totalUnitPrice) &&
            newTableDataLast?.totalUnitPrice !== 0
          ) {
            newTableDataLast.discount =
              (newTableDataLast?.discountMoney /
                newTableDataLast?.totalUnitPrice) *
              100
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            newTableDataLast.totalUnitPriceAfterTax =
              newTableDataLast.totalUnitPrice +
              newTableDataLast.taxMoney -
              newTableDataLast.discountMoney
          }
          break
        case 'discount':
          if (
            !Utils.isObjectEmpty(newTableDataLast?.totalUnitPrice) &&
            newTableDataLast?.totalUnitPrice !== 0
          ) {
            newTableDataLast.discountMoney =
              (newTableDataLast?.discount * newTableDataLast?.totalUnitPrice) /
              100
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            newTableDataLast.totalUnitPriceAfterTax =
              newTableDataLast.totalUnitPrice +
              newTableDataLast.taxMoney -
              newTableDataLast.discountMoney
          }
          break

        case 'totalUnitPrice':
          // chia ngược khi có tổng tiền
          if (formik.values.autoCalculate) {
            if (
              newTableDataLast.quantity &&
              newTableDataLast.quantity !== 0 &&
              persistent === 'quantityPersistent'
            ) {
              /** don gia */
              newTableDataLast.unitPrice = truncateToSixDecimals(
                newTableDataLast.totalUnitPrice / newTableDataLast.quantity,
                true,
              )
              /* don gia sau thue */
              if (_.isNumber(taxRate))
                newTableDataLast.unitPriceAfterTax =
                  (newTableDataLast.unitPrice *
                    (1 + taxRate - newTableDataLast.discount)) /
                  10
              if (!_.isNumber(taxRate))
                newTableDataLast.unitPriceAfterTax =
                  newTableDataLast.unitPrice *
                  (100 - newTableDataLast.discount) *
                  10
            }
            if (
              // Nếu là phiếu xuất kho và có phiếu xuất kho
              newTableDataLast.actualExport &&
              newTableDataLast.actualExport !== 0 &&
              persistent === 'quantityPersistent' &&
              isDeliveryBill
            ) {
              newTableDataLast.unitPrice =
                newTableDataLast.totalUnitPrice / newTableDataLast.actualExport
            } else if (
              // nếu là phiếu xuất kho nội bộ và thực xuất bằng 0
              !newTableDataLast.actualExport &&
              isDeliveryBill &&
              invoiceType == 'N'
            ) {
              newTableDataLast.unitPrice = 0
            }
            if (
              newTableDataLast.unitPrice &&
              persistent === 'priceAfterTaxPersistent'
            ) {
              /** don gia */
              newTableDataLast.quantity = newTableDataLast.actualExport =
                newTableDataLast.totalUnitPrice / newTableDataLast.unitPrice
            }
            /* tien ck */
            newTableDataLast.discountMoney =
              (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
              100
            /*  tien vat */
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            /* tien sau thue */
            newTableDataLast.totalUnitPriceAfterTax =
              newTableDataLast.totalUnitPrice +
              newTableDataLast.taxMoney -
              newTableDataLast.discountMoney
            /* Nếu số lượng, đơn giá là 0 thì để là null */
            if (newTableDataLast.quantity === 0)
              newTableDataLast.quantity = null
            if (newTableDataLast.actualExport === 0)
              newTableDataLast.actualExport = null
            if (newTableDataLast.actualImport === 0)
              newTableDataLast.actualImport = null
            if (
              newTableDataLast.unitPrice === 0 &&
              invoiceType !== 'N' &&
              !newTableDataLast.actualExport
            )
              newTableDataLast.unitPrice = null
            if (newTableDataLast.unitPriceAfterTax === 0)
              newTableDataLast.unitPriceAfterTax = null
            if (newTableDataLast.discountMoney === 0)
              newTableDataLast.discountMoney = null
            if (newTableDataLast.discount === 0)
              newTableDataLast.discount = null
          }
          break
        case 'unitPrice':
          console.log('newTableDataLast.unitPrice', newTableDataLast.unitPrice)
          if (formik.values.autoCalculate) {
            if (
              newTableDataLast.totalUnitPrice &&
              Utils.isObjectEmpty(
                isDeliveryBill
                  ? newTableDataLast?.actualExport
                  : newTableDataLast?.quantity,
              )
            ) {
              newTableDataLast.quantity = newTableDataLast.actualExport =
                newTableDataLast.totalUnitPrice / newTableDataLast.unitPrice
            } else if (
              !Utils.parseFormattedNumberToFloat(
                isDeliveryBill
                  ? newTableDataLast?.actualExport
                  : newTableDataLast?.quantity,
              )
            ) {
              newTableDataLast.quantity = newTableDataLast.actualExport = 1
            }
            // chia ngược khi có tổng tiền

            // don gia
            newTableDataLast.totalUnitPrice =
              newTableDataLast.unitPrice *
              (isDeliveryBill
                ? newTableDataLast?.actualExport
                : newTableDataLast?.quantity)
            // don gia sau thue
            if (_.isNumber(taxRate))
              newTableDataLast.unitPriceAfterTax =
                (newTableDataLast.unitPrice *
                  (100 + taxRate - newTableDataLast.discount)) /
                100
            if (!_.isNumber(taxRate))
              newTableDataLast.unitPriceAfterTax =
                (newTableDataLast.unitPrice /
                  (100 - newTableDataLast.discount)) *
                100
            // tien ck
            newTableDataLast.discountMoney =
              (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
              100
            // tien vat
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            // tien sau thue
            newTableDataLast.totalUnitPriceAfterTax =
              newTableDataLast.totalUnitPrice +
              newTableDataLast.taxMoney -
              newTableDataLast.discountMoney
          }
          break
        case 'totalUnitPriceAfterTax':
          // thanh tien = ttst/(1+%Vat)/(1-%ck)
          if (formik.values.autoCalculate) {
            if (_.isNumber(taxRate))
              newTableDataLast.totalUnitPrice =
                (newTableDataLast.totalUnitPriceAfterTax /
                  (100 + taxRate - newTableDataLast.discount)) *
                100
            if (!_.isNumber(taxRate))
              newTableDataLast.totalUnitPrice =
                (newTableDataLast.totalUnitPriceAfterTax -
                  newTableDataLast.taxMoney) /
                (1 - newTableDataLast.discount / 100)
            if (
              newTableDataLast.quantity &&
              newTableDataLast.quantity !== 0 &&
              persistent === 'quantityPersistent'
            ) {
              // don gia
              newTableDataLast.unitPrice =
                newTableDataLast.totalUnitPrice / newTableDataLast.quantity
              // don gia sau thue
              if (_.isNumber(taxRate))
                newTableDataLast.unitPriceAfterTax =
                  newTableDataLast.unitPrice * (1 + taxRate / 100)
              if (!_.isNumber(taxRate))
                newTableDataLast.unitPriceAfterTax = newTableDataLast.unitPrice
            }
            if (
              newTableDataLast.unitPrice &&
              persistent === 'priceAfterTaxPersistent'
            ) {
              newTableDataLast.quantity =
                newTableDataLast.totalUnitPrice / newTableDataLast.unitPrice
            }

            // tien ck
            newTableDataLast.discountMoney =
              (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
              100
            // tien vat
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            /* Nếu số lượng, đơn giá là 0 thì để là null */
            if (newTableDataLast.quantity === 0)
              newTableDataLast.quantity = null
            if (newTableDataLast.unitPrice === 0)
              newTableDataLast.unitPrice = null
            if (newTableDataLast.unitPriceAfterTax === 0)
              newTableDataLast.unitPriceAfterTax = null
            if (newTableDataLast.discountMoney === 0)
              newTableDataLast.discountMoney = null
            if (newTableDataLast.discount === 0)
              newTableDataLast.discount = null
          }
          break
        case 'unitPriceAfterTax': {
          if (formik.values.autoCalculate) {
            if (
              newTableDataLast.totalUnitPriceAfterTax &&
              Utils.isObjectEmpty(newTableDataLast.quantity)
            ) {
              newTableDataLast.quantity =
                newTableDataLast.totalUnitPriceAfterTax /
                newTableDataLast.unitPriceAfterTax
            } else if (
              !Utils.parseFormattedNumberToFloat(newTableDataLast?.quantity)
            ) {
              newTableDataLast.quantity = 1
            }
            // don gia
            if (_.isNumber(taxRate))
              newTableDataLast.unitPrice =
                (newTableDataLast.unitPriceAfterTax /
                  (100 + taxRate - newTableDataLast.discount)) *
                100
            if (!_.isNumber(taxRate))
              newTableDataLast.unitPrice = newTableDataLast.unitPriceAfterTax
            // thanh tien
            newTableDataLast.totalUnitPrice =
              newTableDataLast.unitPrice * newTableDataLast.quantity
            // tien ck
            newTableDataLast.discountMoney =
              (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
              100
            // tien vat
            if (_.isNumber(taxRate) && formik.values.autoCalculate)
              newTableDataLast.taxMoney =
                ((newTableDataLast.totalUnitPrice -
                  newTableDataLast.discountMoney) *
                  taxRate) /
                100
            // tien sau thue
            newTableDataLast.totalUnitPriceAfterTax =
              newTableDataLast.totalUnitPrice +
              newTableDataLast.taxMoney -
              newTableDataLast.discountMoney
          }
          break
        }
        case 'taxMoney':
          break

        default: // tính theo chiều thuận
          if (formik.values.autoCalculate) {
            if (
              !Utils.isObjectEmpty(
                isDeliveryBill && formik.values.invoiceType === 'N'
                  ? newTableDataLast?.actualExport
                  : newTableDataLast?.quantity,
              ) &&
              !Utils.isObjectEmpty(newTableDataLast?.unitPrice)
            ) {
              if (invoiceSetting?.priceAfterTax) {
                newTableDataLast.unitPrice =
                  (newTableDataLast?.unitPriceAfterTax /
                    (100 + taxRate - newTableDataLast.discount)) *
                  100
              }
              // thanh tien
              newTableDataLast.totalUnitPrice =
                (isDeliveryBill && formik.values.invoiceType === 'N'
                  ? newTableDataLast?.actualExport
                  : newTableDataLast?.quantity) * newTableDataLast?.unitPrice
              // tien ck
              newTableDataLast.discountMoney =
                (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
                100
              // tien vat
              if (_.isNumber(taxRate) && formik.values.autoCalculate)
                newTableDataLast.taxMoney =
                  ((newTableDataLast.totalUnitPrice -
                    newTableDataLast.discountMoney) *
                    taxRate) /
                  100
              // tien sau thue
              newTableDataLast.totalUnitPriceAfterTax =
                newTableDataLast.totalUnitPrice +
                newTableDataLast.taxMoney -
                newTableDataLast.discountMoney
            } else if (
              !Utils.isObjectEmpty(
                isDeliveryBill && formik.values.invoiceType === 'N'
                  ? newTableDataLast?.actualExport
                  : newTableDataLast?.quantity,
              ) &&
              !Utils.isObjectEmpty(newTableDataLast?.totalUnitPrice)
            ) {
              // don gia
              newTableDataLast.unitPrice =
                newTableDataLast.totalUnitPrice / newTableDataLast.quantity
              if (invoiceSetting?.priceAfterTax) {
                newTableDataLast.unitPriceAfterTax =
                  newTableDataLast.totalUnitPriceAfterTax /
                  newTableDataLast.quantity
                newTableDataLast.unitPrice =
                  (newTableDataLast.unitPriceAfterTax /
                    (100 + taxRate - newTableDataLast.discount)) *
                  100
              }
              // don gia sau thue
              newTableDataLast.unitPriceAfterTax =
                (newTableDataLast.unitPrice *
                  (100 + taxRate - newTableDataLast.discount)) /
                100
              // tien ck
              newTableDataLast.discountMoney =
                (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
                100
              // tien vat
              if (_.isNumber(taxRate) && formik.values.autoCalculate)
                newTableDataLast.taxMoney =
                  ((newTableDataLast.totalUnitPrice -
                    newTableDataLast.discountMoney) *
                    taxRate) /
                  100
              // tien sau thue
              newTableDataLast.totalUnitPriceAfterTax =
                newTableDataLast.totalUnitPrice +
                newTableDataLast.taxMoney -
                newTableDataLast.discountMoney
            } else if (
              !Utils.isObjectEmpty(newTableDataLast?.unitPrice) &&
              !Utils.isObjectEmpty(newTableDataLast?.totalUnitPrice)
            ) {
              // so luong
              newTableDataLast.quantity =
                newTableDataLast.totalUnitPrice / newTableDataLast.unitPrice
              // don gia sau thue
              newTableDataLast.unitPriceAfterTax =
                (newTableDataLast.unitPrice *
                  (100 + taxRate - newTableDataLast.discountMoney)) /
                100
              // tien ck
              newTableDataLast.discountMoney =
                (newTableDataLast.totalUnitPrice * newTableDataLast.discount) /
                100
              // tien vat
              if (_.isNumber(taxRate) && formik.values.autoCalculate)
                newTableDataLast.taxMoney =
                  ((newTableDataLast.totalUnitPrice -
                    newTableDataLast.discountMoney) *
                    taxRate) /
                  100
              // tien sau thue
              newTableDataLast.totalUnitPriceAfterTax =
                newTableDataLast.totalUnitPrice +
                newTableDataLast.taxMoney -
                newTableDataLast.discountMoney
            }
          }
          break
      }
      break

    case 'taxRate':
      taxRate = e.value
      newTableDataLast.taxRate = taxRate
      if (formik.values.autoCalculate) {
        if (
          (taxRate == '0' ||
            taxRate == '5' ||
            taxRate == '8' ||
            taxRate == '10') &&
          (formik.values.taxType === 1 ||
            formik.values.taxType === 2 ||
            (formik.values.taxType === 3 && !formik.values.multipleTaxRate) ||
            formik.values.multipleTaxRate) &&
          parseInt(formik.values?.serial?.charAt(0)) === 1
        ) {
          taxRate = parseInt(taxRate)
          if (showPriceAfterTax) {
            newTableDataLast.taxMoney =
              (newTableDataLast.totalUnitPriceAfterTax / (taxRate + 100)) *
              taxRate
            newTableDataLast.unitPrice =
              (newTableDataLast.unitPriceAfterTax / (100 + taxRate)) * 100
            newTableDataLast.totalUnitPrice =
              newTableDataLast.unitPrice * newTableDataLast.quantity
          }
          if (!showPriceAfterTax) {
            newTableDataLast.taxMoney =
              (newTableDataLast.totalUnitPrice * taxRate) / 100
          }
        } else {
          newTableDataLast.taxMoney = 0
        }
      }
      break

    case 'taxReductionRate':
      var taxReductionRate = e.value
      newTableDataLast.taxReductionRate = taxReductionRate

      newTableDataLast.taxReduction =
        ((newTableDataLast.totalUnitPrice - newTableDataLast.discountMoney) *
          newTableDataLast.taxReductionRate) /
        100 /
        5
      break

    default: //input không phải số
      if (type === 'addRow') {
        if (row.no === tableData.length)
          newTableData = [
            ...newTableData,
            {
              no: tableData.length + 1,
              name: '',
              type: 1,
              discount: parseInt(formik.values.discount ?? 0),
              discountMoney: 0,
              unit: '',
              unitPrice: 0,
              quantity: 0,
              totalUnitPrice: 0,
              unitPriceAfterTax: 0,
              totalUnitPriceAfterTax: 0,
              taxRate: formik.values.multipleTaxRate
                ? systemTaxRate
                : formik.values?.taxRate,
              taxMoney: 0,
              productId: 0,
            },
          ]
      }
      if (field === 'name') {
        const textarea = e.target
        if (textarea.scrollHeight > 40) {
          textarea.style.height = 'auto'
          const parentTextArea = textarea.parentNode
          parentTextArea.style.height = '100%'
          textarea.style.height = textarea?.scrollHeight + 'px'
        }
      }
      if (field.startsWith('extendField')) {
        newTableDataLast[field].value = e.target.value
        break
      }

      newTableDataLast[field] = e.target.value
      break
  }
  if (
    field === 'unit' ||
    field === 'inventoryItemCode' ||
    field === 'specification'
  ) {
    newTableDataLast[field] = value
  }
  // case taxMoney đã xử lý ở trên
  if (field !== 'taxMoney') {
    if (!formik.values.isTaxReduction) newTableDataLast.taxReductionRate = 0
    newTableDataLast.taxReduction =
      ((newTableDataLast.totalUnitPrice - newTableDataLast.discountMoney) *
        newTableDataLast.taxReductionRate) /
      100 /
      5
    // check taxRate có phải number k
    if (_.isNumber(taxRate) && formik.values.autoCalculate)
      newTableDataLast.taxMoney =
        ((newTableDataLast.totalUnitPrice - newTableDataLast.discountMoney) *
          taxRate) /
        100
  }
  // làm tròn số
  newTableDataLast.quantity =
    newTableDataLast.quantity &&
    Utils.roundNumber(newTableDataLast.quantity, formatNumber?.quantity)

  // đơn giá
  newTableDataLast.unitPriceAfterTax =
    newTableDataLast.unitPriceAfterTax &&
    Utils.roundNumber(
      newTableDataLast.unitPriceAfterTax,
      // roundingConfig('unitPrice'),

      ['VNĐ', 'VND'].includes(formik.values.currency)
        ? formatNumber?.unitPrice
        : formatNumber?.currencyUnitPrice,
    )
  newTableDataLast.totalUnitPriceAfterTax = Utils.roundNumber(
    newTableDataLast.totalUnitPriceAfterTax,
    // roundingConfig('totalAmount'),

    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )

  newTableDataLast.unitPrice =
    newTableDataLast.unitPrice &&
    Utils.roundNumber(
      newTableDataLast.unitPrice,

      ['VNĐ', 'VND'].includes(formik.values.currency)
        ? formatNumber?.unitPrice
        : formatNumber?.currencyUnitPrice,
    )
  newTableDataLast.totalUnitPrice = Utils.roundNumber(
    newTableDataLast.totalUnitPrice,
    // roundingConfig('totalAmount'),

    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.discount =
    newTableDataLast.discount &&
    Utils.roundNumber(newTableDataLast.discount, formatNumber?.ratio)
  newTableDataLast.discountMoney =
    newTableDataLast.discountMoney &&
    Utils.roundNumber(
      newTableDataLast.discountMoney,
      // formatNumber?.currencyExchange,
      ['VNĐ', 'VND'].includes(formik.values.currency)
        ? formatNumber?.currencyExchange
        : formatNumber?.foreignCurrency,
    )
  newTableDataLast.taxMoney = Utils.roundNumber(
    newTableDataLast.taxMoney,
    // roundingConfig('totalAmount'),

    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.taxReduction = Utils.roundNumber(
    newTableDataLast.taxReduction,
    // formatNumber?.currencyExchange,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  // tính tiền quy đổi cho mỗi row
  console.log(
    'ziiiiiiiiiiiiiiiiiiiiiiiiiiiiii',
    newTableDataLast?.totalUnitPrice,
  )
  newTableDataLast.exchangedTotalUnitPrice = Utils.roundNumber(
    newTableDataLast?.totalUnitPrice * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.exchangedTaxMoney = Utils.roundNumber(
    newTableDataLast?.taxMoney * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.exchangedDiscountMoney = Utils.roundNumber(
    newTableDataLast?.discountMoney * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.taxReductionExchange = Utils.roundNumber(
    newTableDataLast?.taxReduction * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  setTableData(newTableData)
}

export const handleChangeGTGT = ({
  taxRate,
  formik,
  tableData,
  setIsChangeTable,
  showPriceAfterTax,
  setTableData,
}) => {
  setIsChangeTable(true)
  const { exchangeRate } = formik.values
  let newTableData = [...tableData]
  formik.setFieldValue('taxRate', taxRate)
  newTableData.forEach((item) => {
    item.taxRate = taxRate
    let intTaxRate
    if (
      (taxRate == '0' || taxRate == '5' || taxRate == '8' || taxRate == '10') &&
      (formik.values.taxType === 1 ||
        formik.values.taxType === 2 ||
        (formik.values.taxType === 3 && !formik.values.multipleTaxRate) ||
        formik.values.multipleTaxRate) &&
      parseInt(formik.values?.serial?.charAt(0)) === 1
    ) {
      intTaxRate = parseInt(taxRate)
    } else if (taxRate !== 'KHAC') {
      intTaxRate = 0
    }
    if (showPriceAfterTax) {
      if (_.isNumber(intTaxRate))
        item.unitPrice = item.unitPriceAfterTax / (1 + intTaxRate / 100)
      if (!_.isNumber(intTaxRate)) item.unitPrice = item.unitPriceAfterTax
      item.totalUnitPrice = item.unitPrice * item.quantity
    }
    item.discountMoney = (item.discount * item.totalUnitPrice) / 100
    item.taxMoney = _.isNumber(intTaxRate)
      ? ((item.totalUnitPrice - item.discountMoney) * intTaxRate) / 100
      : item.taxMoney
    item.exchangedTaxMoney = item.taxMoney * exchangeRate
    item.exchangedDiscountMoney = item.discountMoney * exchangeRate
    item.exchangedTotal = item.totalUnitPrice * exchangeRate
    item.exchangedTotalUnitPriceAfterTax =
      item.totalUnitPriceAfterTax * exchangeRate
  })
  setTableData(newTableData)
}

export const handleSelectDiscountType = ({
  discountType,
  tableData,
  formik,
  setTableData,
}) => {
  let newTableData = [...tableData]

  newTableData.map((item) => {
    let taxRate = item.taxRate
    let taxMoney = 0
    if (formik.values.multipleTaxRate) {
      taxRate = parseInt(taxRate)
    } else if (
      (item.taxRate == '0' ||
        item.taxRate == '5' ||
        item.taxRate == '8' ||
        item.taxRate == '10') &&
      (formik.values.taxType === 1 ||
        formik.values.taxType === 2 ||
        (formik.values.taxType === 3 && !formik.values.multipleTaxRate) ||
        formik.values.multipleTaxRate) &&
      parseInt(formik.values?.serial?.charAt(0)) === 1
    ) {
      taxRate = parseInt(taxRate)
    } else if (taxRate !== 'KHAC') {
      taxRate = 0
    }
    if (_.isNumber(taxRate)) taxMoney = (item.totalUnitPrice * taxRate) / 100

    item.discount = 0
    item.discountMoney = 0
    item.exchangedDiscountMoney = 0
    item.taxMoney = taxMoney
  })

  setTableData(newTableData)
  formik.setFieldValue('discount', 0)
  formik.setFieldValue('discountMoney', 0)
  formik.setFieldValue('exchangedDiscountMoney', 0)
  formik.setFieldValue('discountType', discountType)
}

export const handleSelectProduct = ({
  product,
  row,
  type,
  formik,
  tableData,
  isDeliveryBill,
  formatNumber,
  roundingConfig,
  setTableData,
  handleAddRow,
}) => {
  let exchangeRate = Utils.parseFormattedNumberToFloat(
    formik.values.exchangeRate,
  )
  let newTableData = [...tableData]
  let newTableDataLast = newTableData[row.no - 1]
  newTableDataLast.name = product?.name ?? ''
  if (newTableDataLast.type === 4) return
  newTableDataLast.unit = product?.unit ?? ''
  newTableDataLast.inventoryItemCode = product?.code ?? ''
  newTableDataLast.productId = product?.productId ?? 0
  let taxRate = formik.values.taxRate
  if (formik.values.multipleTaxRate) {
    newTableDataLast.taxRate = product?.vat ?? '0'
    taxRate = parseInt(newTableDataLast.taxRate)
  } else if (
    (newTableDataLast.taxRate == '0' ||
      newTableDataLast.taxRate == '5' ||
      newTableDataLast.taxRate == '8' ||
      newTableDataLast.taxRate == '10') &&
    (formik.values.taxType === 1 ||
      formik.values.taxType === 2 ||
      (formik.values.taxType === 3 && !formik.values.multipleTaxRate) ||
      formik.values.multipleTaxRate) &&
    parseInt(formik.values?.serial?.charAt(0)) === 1
  ) {
    taxRate = parseInt(newTableDataLast.taxRate)
  } else if (taxRate !== 'KHAC') {
    taxRate = 0
  }
  newTableDataLast.discount = 0
  if (
    formik.values.discountType === DISCOUNT_TYPE.EACH_ITEM &&
    product?.discountRate
  ) {
    newTableDataLast.discount =
      newTableDataLast.type === 3 ? 0 : (product?.discountRate ?? 0)
  }

  // if (
  //   newTableDataLast.taxRate === 'KCT' ||
  //   newTableDataLast.taxRate === 'KHAC' ||
  //   newTableDataLast.taxRate === 'KKKNT'
  // ) {
  //   taxRate = newTableDataLast.taxRate
  // }
  newTableDataLast.quantity = 1

  // nếu là pxk kiêm vận chuyển nội bộ thì mới gán
  if (isDeliveryBill && formik.values.invoiceType === 'N')
    newTableDataLast.actualExport = newTableDataLast.actualImport = 1
  if (formik.values.isTaxReduction) newTableDataLast.taxReductionRate = 1
  if (!formik.values.isTaxReduction) newTableDataLast.taxReductionRate = 0
  // if (typeof taxRate !== 'number') {
  //   taxRate = 0
  // }
  if (product.priceAfterTax) {
    newTableDataLast.unitPriceAfterTax = product?.price ?? 0
    //tinh don gia truoc thue
    newTableDataLast.unitPrice = _.isNumber(taxRate)
      ? newTableDataLast.unitPriceAfterTax / (1 + taxRate / 100)
      : newTableDataLast.unitPriceAfterTax
  }
  if (!product.priceAfterTax) {
    newTableDataLast.unitPrice = Number(product?.price) ?? 0
    //tinh don gia sau thue
    newTableDataLast.unitPriceAfterTax = _.isNumber(taxRate)
      ? newTableDataLast.unitPrice * (1 + taxRate / 100)
      : newTableDataLast.unitPrice
  }
  // tinh tien chiet khau
  newTableDataLast.discountMoney =
    newTableDataLast.type === 3
      ? 0
      : (newTableDataLast.unitPrice * newTableDataLast.discount) / 100
  // vat
  if (_.isNumber(taxRate))
    newTableDataLast.taxMoney =
      ((newTableDataLast.unitPrice - newTableDataLast.discountMoney) *
        taxRate) /
      100
  //tổng tiền
  newTableDataLast.totalUnitPrice =
    newTableDataLast.unitPrice * newTableDataLast.quantity
  // tổng tiền sau thuế, ck
  newTableDataLast.totalUnitPriceAfterTax =
    newTableDataLast.totalUnitPrice -
    newTableDataLast.discountMoney +
    newTableDataLast.taxMoney
  // tổng tiền chiết khấu quy đổi
  newTableDataLast.exchangedDiscountMoney =
    newTableDataLast.discountMoney * exchangeRate
  // thành tiền quy đổi
  newTableDataLast.exchangedTotalUnitPrice =
    newTableDataLast.totalUnitPrice * exchangeRate
  // tiền thuế GTGT được giảm
  newTableDataLast.taxReduction =
    ((newTableDataLast.totalUnitPrice - newTableDataLast.discountMoney) *
      newTableDataLast.taxReductionRate) /
    100 /
    5
  // tiền thuế GTGT được giảm quy đổi
  newTableDataLast.taxReductionExchange =
    newTableDataLast.taxReduction * exchangeRate

  // làm tròn số
  newTableDataLast.quantity = Utils.roundNumber(
    newTableDataLast.quantity,
    formatNumber?.quantity,
  )
  newTableDataLast.unitPriceAfterTax = Utils.roundNumber(
    newTableDataLast.unitPriceAfterTax,
    // formatNumber?.unitPrice,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.unitPrice
      : formatNumber?.currencyUnitPrice,
  )
  newTableDataLast.totalUnitPriceAfterTax = Utils.roundNumber(
    newTableDataLast.totalUnitPriceAfterTax,
    // formatNumber?.totalAmount,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.unitPrice = Utils.roundNumber(
    newTableDataLast.unitPrice,

    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.unitPrice
      : formatNumber?.currencyUnitPrice,
  )
  newTableDataLast.totalUnitPrice = Utils.roundNumber(
    newTableDataLast.totalUnitPrice,
    formatNumber?.totalAmount,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.unitPrice
      : formatNumber?.currencyUnitPrice,
  )
  newTableDataLast.discount = Utils.roundNumber(
    newTableDataLast.discount,
    // formatNumber?.ratio,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.discountMoney = Utils.roundNumber(
    newTableDataLast.discountMoney,
    // formatNumber?.currencyExchange,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.taxMoney = Utils.roundNumber(
    newTableDataLast.taxMoney,
    // formatNumber?.totalCost,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )
  newTableDataLast.taxReduction = Utils.roundNumber(
    newTableDataLast.taxReduction,
    // formatNumber?.currencyExchange,
    ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber?.currencyExchange
      : formatNumber?.foreignCurrency,
  )

  // tính tiền quy đổi cho mỗi row
  newTableDataLast.exchangedTotalUnitPrice = Utils.roundNumber(
    newTableDataLast.exchangedTotalUnitPrice,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.exchangedTaxMoney = Utils.roundNumber(
    newTableDataLast?.taxMoney * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.exchangedDiscountMoney = Utils.roundNumber(
    newTableDataLast?.discountMoney * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )
  newTableDataLast.taxReductionExchange = Utils.roundNumber(
    newTableDataLast?.taxReduction * exchangeRate,
    formatNumber?.currencyExchange,
    // ['VNĐ', 'VND'].includes(formik.values.currency)
    //   ? formatNumber?.currencyExchange
    //   : formatNumber?.foreignCurrency,
  )

  if (type === 'addRow' && newTableDataLast.name.length > 0) {
    return handleAddRow(row, newTableData)
  }
  return setTableData(newTableData)
}
